interface NavVisibilityWorkspace {
	domainPublic?: boolean | null
	changelogPublic?: boolean | null
	customerPortalSettings?: { isEnabled?: boolean | null } | null
}

// Docs is always visible; its content is editable whether or not it is published.
export function isNavItemUnpublished(
	title: string,
	workspace: NavVisibilityWorkspace | null | undefined,
): boolean {
	if (title === "Docs") return false
	if (title === "Feature requests") return workspace?.domainPublic === false
	if (title === "Changelog") return workspace?.changelogPublic === false
	if (title === "Support portal")
		return workspace != null && !workspace.customerPortalSettings?.isEnabled
	return false
}

// Trial workspaces see it too; unpublished surfaces are what they are there to try.
export function shouldShowTrySection({
	collapsed,
	dismissed,
	unpublishedCount,
}: {
	collapsed: boolean
	dismissed: boolean
	unpublishedCount: number
}): boolean {
	return !collapsed && !dismissed && unpublishedCount > 0
}
